// Подсказката „Продадено без наличност" в модала „Запис на доставката": за всеки
// продукт от доставката, който е на минус от продажби — какво ще стане с минуса
// при избраната дата и коя дата би го покрила. Само подсказка: записът не се
// спира. Без продукт на минус не рендира нищо.
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useProducts } from "../../../../hooks/useInventory";
import { useNegativeStock } from "../../../../hooks/useInventoryNegativeStock";
import { useUnitDecimals } from "../../components/qty";
import { negativeHintsOf, negativeStockParamsOf, type IncomingLine } from "./deliveryNegativeHint";

type Props = {
  date: string; // YYYY-MM-DD — датата от модала
  lines: IncomingLine[];
  editMovementId: number | null;
};

export const DeliveryNegativeStockHint = ({ date, lines, editMovementId }: Props) => {
  const { t } = useTranslation();
  const { data: products = [] } = useProducts();
  const decimalsOf = useUnitDecimals();
  const params = useMemo(
    () => (date ? negativeStockParamsOf(lines, date, editMovementId) : []),
    [lines, date, editMovementId],
  );
  const negatives = useNegativeStock(params);
  const productById = useMemo(() => new Map(products.map((product) => [product.id, product])), [products]);
  const hints = negativeHintsOf(
    lines,
    negatives,
    (productId) => ({
      name: productById.get(productId)?.name ?? `#${productId}`,
      unit: productById.get(productId)?.unit ?? null,
      decimals: decimalsOf(productId),
    }),
    date,
    t,
  );
  if (!date || !hints.length) return null;
  return (
    <div role="note" className="flex flex-col gap-1.5 rounded-[9px] bg-warn-tint px-[13px] py-[11px] text-warn-ink">
      <span className="text-[11px] font-semibold uppercase tracking-[0.1em]">⚠ {t("inventoryPage.saveNegTitle")}</span>
      {hints.map((hint) => (
        <p key={hint.key} className="m-0 text-[13px] leading-[1.45]">
          {hint.sentences.join(" ")}
        </p>
      ))}
    </div>
  );
};

export default DeliveryNegativeStockHint;
